import {
  IStoreState,
  getFlightMarkersState,
  getSiteState,
} from "../../rootReducer";
import { IGcpAppDispatch } from "../../store";
import { persistFlightMarkers } from "./flightMarkersReducer";
import { getSiteSrs } from "../site/reducer";
import {
  fetchFlightMarkers,
  updateFlightMarkers,
} from "../../../apiFacades/bapi/flightMarkers";

export const loadFlightMarkers =
  (customerId: string, siteId: string) => async (dispatch: IGcpAppDispatch) => {
    const flightMarkersList = await dispatch(
      fetchFlightMarkers(customerId, siteId),
    );
    if (!flightMarkersList.length) {
      throw new Error("Empty Flight Markers list received");
    }
    dispatch(persistFlightMarkers(flightMarkersList));
  };

export const saveFlightMarkers =
  (customerId: string, siteId: string) =>
  async (dispatch: IGcpAppDispatch, getState: () => IStoreState) => {
    const flightMarkersState = getFlightMarkersState(getState());
    const srs = getSiteSrs(getSiteState(getState()));

    if (flightMarkersState.data) {
      await dispatch(
        updateFlightMarkers(
          customerId,
          siteId,
          flightMarkersState.data.nails,
          srs,
        ),
      );
    }
  };
